import { styled } from '@mui/material/styles';

export const StyledHideBackToTopButton = styled('div')`
    visibility: 'hidden';
`;
